import { z } from 'zod';

const ReplacedEntrySchema = z.object({
  enabled: z.boolean(),
  value: z.string(),
});

const ReplacedDictSchema = z.record(z.string(), ReplacedEntrySchema);

const TranslatedReplacedDictSchema = z.record(z.string(), ReplacedDictSchema);

export const MergedVariablesSchema = z.object({
  replacements: ReplacedDictSchema,
  translations: TranslatedReplacedDictSchema,
});
